import React, { ChangeEvent, FunctionComponent } from 'react';
import { SegmentedControlOptions } from 'scenes/common/components/Questions';

import { CoverTypeSelectionStep as CommonCoverTypeSelectionStep } from 'scenes/common/components/Steps';
import { CoverType, InsuranceName } from 'scenes/common/types';
import { getDiscountCopy } from 'scenes/home/helpers/Discount/discount';

import { getCoverType } from 'scenes/home/selectors';
import { HomeFormState, HomeFullPageProps } from 'scenes/home/types';

const OPTIONS: SegmentedControlOptions<string, CoverType> = [
  {
    label: CoverType.BuildingAndContents,
    value: CoverType.BuildingAndContents,
  },
  {
    label: `${CoverType.Contents} (for Owners or Renter)`,
    value: CoverType.Contents,
  },
  { label: CoverType.Building, value: CoverType.Building },
];

const CoverTypeSelectionStep: FunctionComponent<HomeFullPageProps> = ({
  funnelState,
  onNext,
  onResetPropertyBuiltYear,
  onSetCoverType,
}) => {
  const onCoverTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (onResetPropertyBuiltYear) {
      onResetPropertyBuiltYear();
    }
    if (onSetCoverType) {
      const currentOption = event.target.value as CoverType;
      onSetCoverType(currentOption);
    }
  };

  return (
    <CommonCoverTypeSelectionStep
      onNext={(values: HomeFormState) => onNext(values)}
      defaultStateValue={getCoverType(funnelState)}
      insuranceName={InsuranceName.Home}
      question={`Select ${InsuranceName.Home} insurance cover`}
      options={OPTIONS}
      helpText={getDiscountCopy(getCoverType(funnelState))}
      onChangeCallback={onCoverTypeChange}
    />
  );
};
export default CoverTypeSelectionStep;
